import { Injectable } from "@angular/core";
import { LoginProviderEnum } from "../enums/login-provider-enum";
import { LoginType } from "../models/members/user/user-context.model";
import { CreateUserInfoModel } from "../models/members/user/create-user-info.model";

@Injectable({
    providedIn: 'root'
})
export class OAuthRedirectTokenizerService {
    private loginType: LoginType | undefined;

    getLoginType() {
        var loginType: LoginType | undefined;

        switch (localStorage.getItem('TempLoginType')) {
            case '0':
                loginType = LoginType.User;
                break;
            case '1':
                loginType = LoginType.Client;
                break;
            default:
                loginType = undefined;
        }
        return loginType;
    }

    setLoginType(loginType: LoginType | undefined) {
        localStorage.setItem('TempLoginType', JSON.stringify(loginType));
    }

    decodeOauthToken(token: string): CreateUserInfoModel {
        var userInfoModel: CreateUserInfoModel = new CreateUserInfoModel();
        if (token != undefined) {
            var params = JSON.parse(atob(token.split('.')[1]));
            if (params.emails) {
                userInfoModel.user.userName = params.emails[0]!
                userInfoModel.user.email = params.emails[0]!;
            }
            userInfoModel.user.loginProvider = this.assignLoginProvider(params.idp);
            userInfoModel.user.socialId = params.sub;
            userInfoModel.user.fullName = `${params.given_name} ${params.family_name}`;
            userInfoModel.user.password = params.sub; // setting password to socialId to avoid any issues with null/empty password string logins. 
        }

        return userInfoModel;
    }

    getIdpFromToken(token: string): string {
        var idpString = '';
        if (token != undefined) {
            var params = JSON.parse(atob(token.split('.')[1]));
            idpString = params.idp;
        }
        return idpString;
    }

    assignLoginProviderName(idp: string | undefined): string {
        switch (idp) {
            case 'google.com':
                return 'Google';

            case 'facebook.com':
                return 'Facebook';

            case 'apple.com':
                return 'Apple';

            default:
                return 'Azure - B2C'
        }

    }

    assignLoginProvider(idp: string | undefined): LoginProviderEnum {
        switch (idp) {
            case 'google.com':
                return LoginProviderEnum.Google;
            case 'facebook.com':
                return LoginProviderEnum.Facebook;
            case 'apple.com':
                return LoginProviderEnum.Apple;
            default:
                return LoginProviderEnum.AzureActiveDirectory;
        }
    }

}